<template>
  <div>
    <button @click="$emit('regresar')" class="btn-volver">← Menú principal</button>
    <h3>Stands</h3>
    <form @submit.prevent="crearStand" class="form-nuevo-stand">
      <input v-model="nuevoStand.name" placeholder="Nombre del stand" required />
      <input v-model="nuevoStand.logo" placeholder="Logo (URL opcional)" />
      <input v-model="nuevoStand.intereses" placeholder="Intereses (mínimo 3, separar por coma)" required />
      <textarea
        v-model="nuevoStand.sms_message"
        placeholder="Mensaje SMS para asistentes (máx 160 caracteres)"
        maxlength="160"
        @input="nuevoStand.sms_message = nuevoStand.sms_message.slice(0,160)"
      />
      <small>{{ nuevoStand.sms_message.length }}/160 caracteres</small>
      <button type="submit">Agregar</button>
         </form>
    <table>
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Logo</th>
          <th>Intereses</th>
          <th>SMS</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="s in stands" :key="s.id">
          <td>
            <template v-if="editId === s.id">
              <input v-model="editStand.name" required />
            </template>
            <template v-else>
              {{ s.name }}
            </template>
          </td>
          <td>
            <template v-if="editId === s.id">
              <input v-model="editStand.logo" placeholder="Logo URL" />
            </template>
            <template v-else>
              <img v-if="s.logo" :src="s.logo" alt="logo" style="max-width:60px;" />
            </template>
          </td>
          <td>
            <template v-if="editId === s.id">
              <input v-model="editStand.intereses" required />
              <small>Ejemplo: Pippap,Coolers,Seguridad,Otro</small>
            </template>
            <template v-else>
              <span v-if="mostrarIntereses(s.interests).length" v-for="i in mostrarIntereses(s.interests)" :key="i" class="chip">{{ i }}</span>
              <span v-else style="color:#aaa">Sin intereses</span>
            </template>
          </td>
          <td>
            <template v-if="editId === s.id">
              <textarea
                v-model="editStand.sms_message"
                maxlength="160"
                @input="editStand.sms_message = editStand.sms_message.slice(0,160)"
              />
              <small>{{ editStand.sms_message.length }}/160</small>
            </template>
            <template v-else>
              <span v-if="s.sms_message">{{ s.sms_message }}</span>
              <span v-else style="color:#aaa">—</span>
            </template>
          </td>
          <td>
            <template v-if="editId === s.id">
              <button @click="guardarEdicion(s.id)">Guardar</button>
              <button @click="cancelarEdicion">Cancelar</button>

            </template>
            <template v-else>
              <button @click="editarStand(s)">Editar</button>
              <button @click="eliminarStand(s.id)">Eliminar</button>
               <button @click="generarQR(s.id)">QR</button>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  props: ['token'],
  data() {
    return {
      stands: [],
      editId: null,
      editStand: { name: '', logo: '', intereses: '', sms_message: '' },
      nuevoStand: { name: '', logo: '', intereses: '', sms_message: '' }
    }
  },
  async mounted() { await this.cargarStands() },
  methods: {
     
  generarQR(standId) {
    if (!standId) {
      alert("Error: No se detectó el ID del stand.");
      return;
    }
    const url = `${window.location.origin}/registro/${standId}`;
    const qrApi = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(url)}`;
    window.open(qrApi, '_blank');
  },

    mostrarIntereses(val) {
      // Robust: si viene como JSON o como array (o como string plano)
      if (!val) return []
      if (Array.isArray(val)) return val
      try {
        const arr = JSON.parse(val)
        if (Array.isArray(arr)) return arr
        return []
      } catch {
        // fallback si está en texto plano separado por comas
        return val.split(',').map(s => s.trim()).filter(Boolean)
      }
    },
    async cargarStands() {
      const res = await axios.get('/api/stands', { headers: { Authorization: 'Bearer ' + this.token } })
      this.stands = res.data
    },
    async crearStand() {
      // Validar mínimo 3 intereses y "Otro" forzoso
      let intereses = this.nuevoStand.intereses.split(',').map(i => i.trim()).filter(Boolean)
      if (intereses.length < 3) return alert("Debes ingresar al menos 3 intereses.")
      if (!intereses.map(i => i.toLowerCase()).includes('otro')) intereses.push('Otro')
      const payload = {
        name: this.nuevoStand.name,
        logo: this.nuevoStand.logo,
        interests: JSON.stringify(intereses),
        sms_message: this.nuevoStand.sms_message
      }
      await axios.post('/api/stands', payload, { headers: { Authorization: 'Bearer ' + this.token } })
      this.nuevoStand = { name: '', logo: '', intereses: '', sms_message: '' }
      await this.cargarStands()
    },
    editarStand(s) {
      this.editId = s.id
      this.editStand = {
        name: s.name,
        logo: s.logo,
        intereses: this.mostrarIntereses(s.interests).join(','),
        sms_message: s.sms_message || ''
      }
    },
    async guardarEdicion(id) {
      let intereses = this.editStand.intereses.split(',').map(i => i.trim()).filter(Boolean)
      if (intereses.length < 3) return alert("Debes ingresar al menos 3 intereses.")
      if (!intereses.map(i => i.toLowerCase()).includes('otro')) intereses.push('Otro')
      const payload = {
        name: this.editStand.name,
        logo: this.editStand.logo,
        interests: JSON.stringify(intereses),
        sms_message: this.editStand.sms_message
      }
      await axios.put('/api/stands/' + id, payload, { headers: { Authorization: 'Bearer ' + this.token } })
      this.editId = null
      await this.cargarStands()
    },
    cancelarEdicion() {
      this.editId = null
      this.editStand = { name: '', logo: '', intereses: '', sms_message: '' }
    },
    async eliminarStand(id) {
      if (!confirm('¿Eliminar stand?')) return
      await axios.delete('/api/stands/' + id, { headers: { Authorization: 'Bearer ' + this.token } })
      await this.cargarStands()
    }
  }
}
</script>

<style scoped>
.form-nuevo-stand {
  margin-bottom: 22px;
  background: #f9f9f9;
  padding: 14px;
  border-radius: 7px;
}
input, textarea, button {
  margin-bottom: 7px;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
  font-size: 1em;
  width: 100%;
  box-sizing: border-box;
}
table { width: 100%; margin-top: 10px; }
th, td { padding: 8px 6px; border: 1px solid #eee; }
.chip {
  display: inline-block;
  background: #e3f1e3;
  color: #277d14;
  border-radius: 14px;
  padding: 2px 11px;
  font-size: .92em;
  margin-right: 4px;
  margin-bottom: 2px;
}
.btn-volver {
  background: #555;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 7px 16px;
  margin-bottom: 16px;
  font-weight: bold;
  cursor: pointer;
}
</style>
